/**
 * Capitalizes the given string (givenExampleString => GivenExampleString)
 *
 * @param string string to be convert from camelCase to kebab-case
 */
export function capitalize([firstLetter, ...rest]: string): string {
	return `${firstLetter.toUpperCase()}${rest.join('')}`;
}
